import type { TemplateResult } from 'lit';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { EntityContent } from 'src/content/entity-content';
import { t } from 'src/i18n';
import '../../library/components/d-calendar';
import type { UpdateSectionItem } from '../update-section-item';
import type { ListDefinition } from '../list-definition';
import type { MeetingView } from './meeting-view';

/**
 *
 */
@customElement('d-meeting-view')
export class DMeetingView extends EntityContent<MeetingView, Record<string, never>> {
  protected get currentItemSublabel() {
    return t('meetings.meetingCalendar');
  }

  protected get preventDelete(): boolean {
    return true;
  }

  async initializeEditItem() {
    throw new Error('Illegal state. Meeting view is not editable');
  }

  hideEdit() {
    return true;
  }

  hidePdf() {
    return true;
  }

  renderMeetingCalendar(): TemplateResult<1> {
    return html`<d-calendar
      style="margin-top: -1px"
      .currentYear=${this.entityView.today.year()}
      .occurrences=${this.entityView.occurrences}
      .eventTerm=${t('meetings.eventTerm')}
      .baseHref=${this.entityView.href}
      .addText=${t('meetings.addMeeting')}
      .meetingUuid=${this.entityView.uuid}
      .interviewedEmployeeUuid=${this.entityView.interviewedEmployeeUuid}
      .contentStickyTop=${this.contentStickyTop}
    ></d-calendar> `;
  }

  renderViewMode() {
    return html` ${this.renderFieldSection('reports', this.viewFields(), this.entityView)} `;
  }

  renderHelpSection() {
    return html``;
  }

  renderEditItem(): TemplateResult<1> {
    return html``;
  }

  protected lists(): ListDefinition[] {
    return [
      {
        field: '',
        icon: '',
        items: '',
        type: 'custom',
        render: () => this.renderMeetingCalendar(),
      },
    ];
  }

  protected asUpdateSectionItem(): UpdateSectionItem | undefined {
    return undefined;
  }

  protected renderAttachments(): TemplateResult<1> {
    return html``;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'd-meeting-view': DMeetingView;
  }
}
